/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LiqPrefLedgerItem } from './LiqPrefLedgerItem';
export type LiqPrefLedgerConfig = {
  readonly id?: number;
  threshold_type?: string;
  items?: Array<LiqPrefLedgerItem>;
  readonly created_at?: string;
  readonly updated_at?: string;
  dividend_threshold_type?: LiqPrefLedgerConfig.dividend_threshold_type | null;
};
export namespace LiqPrefLedgerConfig {
  export enum dividend_threshold_type {
    GREATER_OF = 'GREATER_OF',
    LESSER_OF = 'LESSER_OF',
  }
}
